import {cdrSimList,dictCountry} from 'api/cdrSimList';
import Cookies from 'js-cookie';

const cdrSim = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        //test
        cdrSimList({commit},params) {
            return new Promise((resolve, reject) => {
                var accountStart = params.accountStart;
                var accountEnd = params.accountEnd;
                var dateStart = params.dateStart;
                var dateEnd = params.dateEnd;
                var agent = params.agent;
                var zoneId = params.zoneId;
                var psize = params.psize;
                var currentPage = params.currentPage;
                cdrSimList(accountStart,accountEnd,dateStart,dateEnd,agent,zoneId,psize,currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        dictCountry({commit},params){
            return new Promise((resolve, reject) => {
                dictCountry(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default cdrSim;



// WEBPACK FOOTER //
// ./src/store/modules/cdrSimList.js